import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux'

import { Navigation } from '../UserPage/Navigation/Navigation';
import { MyVideo } from '../UserPage/MyVideo/MyVideo';
import { LikedVideo } from '../UserPage/LikedVideo/LikedVideo';
import MyGallery from '../UserPage/MyGallery'
import IdSetting from '../IdSetting/IdSetting';
import { PaymentPoints } from '../UserPage/PaymentPoints/PaymentPoints';
import { PageContent } from '../UserPage/UserPage.style';
import { _onVideoLikedButtonClicked } from '../Routers/designSelect';
import i18n from '../i18n';
import DataManager from '@/utils/DataManager';
import { FetchPaymetMode, FetchCoupons, FetchAccountStatus, UpdateCurrentCredit } from '../Interface'
import { getIsExpiredDate } from '@/utils/DateHelper';
import { POINT_UI_EXPIRED_DATE } from '@/utils/Global';

class UserPage extends Component {

  state = {
    isMounted: false,
    links: []
  };

  refreshUserData = () => {
    this.componentDidMount()
  }

  async componentDidMount() {
    this.FetchData()

    this.setState({
      isMounted: true,
      links: this.getLinks()
    });
  }

  FetchData = async () => {
    if(DataManager.IsProvider(DataManager.PROVIDER.CAFE24)) return;

    FetchPaymetMode()
    FetchCoupons()
    FetchAccountStatus()
    UpdateCurrentCredit()
  }
  getLinks = () => {
    if(DataManager.IsProvider(DataManager.PROVIDER.CAFE24)) {
      return [
        { name: 'my-video', text: i18n.t("myvideo.title") },
        { name: 'liked-video', text: i18n.t("navigator.login.before.likedvideo"), isNewTab: true },
        { name: 'payment-and-points', text: i18n.t("Cafe24.paymenthistory.title") }
      ]
    }else {
      return [
        { name: 'my-video', text: i18n.t("myvideo.title") },
        { name: 'my-gallery', text: i18n.t("web.mygallery.title") },
        { name: 'liked-video', text: i18n.t("navigator.login.before.likedvideo") },
        { name: 'account-setting', text: i18n.t("accountsetting.component.name") },
        { name: 'payment-and-points', text: i18n.t("paymentpoints.title") }
      ]
    }
  }
  onVideoLikedButtonClicked = (selectedVideo, likedVideos) => e => {
    _onVideoLikedButtonClicked(this, selectedVideo, likedVideos);
  };

  getRoutes = (match, history, currentUser) => {
    const filterPathList = this.state.links.map(link => link.name)
    const routes = [
      {
        path: `${match.url}/my-gallery`,
        component: props => (
          <MyGallery
          history={history}
          isMounted={this.state.isMounted}
          currentUser={currentUser}
          refreshUserData={this.refreshUserData}
          value={this.props.value}
        />
        )
      },
      {
        path: `${match.url}/liked-video`,
        component: props => (
          <LikedVideo
            isMounted={this.state.isMounted}
            currentUser={currentUser}
            history={history}
            onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
            refreshUserData={this.refreshUserData}
            value={this.props.value}
          />
        )
      },
      {
        path: `${match.url}/account-setting`,
        component: props => (
          <IdSetting
            {...props}
            currentUser={currentUser}
            refreshUserData={this.refreshUserData}
            value={this.props.value}
          />
        )
      },
      {
        path: `${match.url}/payment-and-points`,
        component: props => (
          <PaymentPoints
            {...props}
            refreshUserData={this.refreshUserData}
            value={this.props.value}
          />
        )
      }
    ];
    return routes.filter(route => filterPathList.includes(route.path.split('/')[3]));
  }

  render() {
    const { links } = this.state;
    const { match, history, currentUser } = this.props
    if (!localStorage.getItem('token') && currentUser === undefined) {
      history.push({
        pathname: `/`
      });
      return null;
    }

    return (
      <div className="prohibit-drag">
        <Navigation value={this.props.value} match={match} links={links} />
        <PageContent>
          <Route
            exact
            path={match.url}
            component={props => (
              <MyVideo
                value={this.props.value}
                isMounted={this.state.isMounted}
                history={history}
                currentUser={currentUser}
                refreshUserData={this.refreshUserData}
              />
            )}
          />
          <Route
            path={`${match.url}/my-video`}
            component={props => (
              <MyVideo
                history={history}
                isMounted={this.state.isMounted}
                currentUser={currentUser}
                refreshUserData={this.refreshUserData}
                value={this.props.value}
              />
            )}
          />
          {this.getRoutes(match, history, currentUser).map(route => <Route key={route.path} {...route} />)}
        </PageContent>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  value: state.langStore.lang,
  accountStatus: state.accountStatusStore.accountStatus,
})

export default connect(
  mapStateToProps,
  null
)(UserPage)

export const makeTempUserId = currentUser => {
  return currentUser && currentUser.email ? currentUser.email : '_';
};
